module.exports = __webpack_public_path__ + "static/media/dark-kitchen.4949dd1b.jpg";